export default "__VITE_ASSET__02a1214b__"